

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-address-normalization.route', ['squid', 'xo-address-normalization.directive']).factory('$AddressNormalizationRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddressNormalizationRoute', {

            name: 'addressNormalization',
            titleContent: 'addressNormalization.addressmatch',
            directive: 'xo-address-normalization',
            trackingData: {
                fptiState: 'address_normalization'
            },
            loginRequired: true,

            children: []
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-address-components/src/address-normalization/route.js
 ** module id = 292
 ** module chunks = 1
 **/